/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Blockactiveregistrationhoursinadvance5Inputs */

const en__field_blockactiveregistrationhoursinadvance5 = /** @type {(inputs: _Field_Blockactiveregistrationhoursinadvance5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Registration Deadline`)
};

const de__field_blockactiveregistrationhoursinadvance5 = /** @type {(inputs: _Field_Blockactiveregistrationhoursinadvance5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Anmeldefrist`)
};

/**
* | output |
* | --- |
* | "Active Registration Deadline" |
*
* @param {_Field_Blockactiveregistrationhoursinadvance5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_blockactiveregistrationhoursinadvance5 = /** @type {((inputs?: _Field_Blockactiveregistrationhoursinadvance5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Blockactiveregistrationhoursinadvance5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_blockactiveregistrationhoursinadvance5(inputs)
	return de__field_blockactiveregistrationhoursinadvance5(inputs)
});
export { _field_blockactiveregistrationhoursinadvance5 as "_field_blockActiveRegistrationHoursInAdvance" }